// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1HWnx","title":"ClientCherryInfo_title__v20GE","itemText":"ClientCherryInfo_itemText__36Zaj"};